<template>
  <div class="appeal-review-fullscreen">
    <AppealReview 
      v-if="batchId"
      :batch-id="batchId"
      @back="handleBack"
    />
    <div v-else class="loading-tip">
      <p>参数错误，请返回</p>
      <el-button @click="handleBack">返回</el-button>
    </div>
  </div>
</template>

<script>
import AppealReview from './AppealReview.vue'

export default {
  name: 'AppealReviewPage',
  components: { AppealReview },
  
  computed: {
    batchId() {
      return this.$route.query.batchId || ''
    }
  },
  
  methods: {
    handleBack() {
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.push('/project')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.appeal-review-fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  background: #f5f7fa;
}

.loading-tip {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #909399;
}
</style>
